/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_FrInputs */

const en_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const es_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const de_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const zh_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const ar_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const fr_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const vi_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const sw_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const th_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const bs_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const ja_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const ko_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const pt_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const it_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const sv_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const nl_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const da_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const nb_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const fi_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const pl_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const ru_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const tr_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const hi_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const id_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const ms_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const cs_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const el_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const he_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const af_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const hu_nav_language_fr = /** @type {(inputs: Nav_Language_FrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

/**
* | output |
* | --- |
* | "Français" |
*
* @param {Nav_Language_FrInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_fr = /** @type {((inputs?: Nav_Language_FrInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_FrInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_fr(inputs)
	if (locale === "de") return de_nav_language_fr(inputs)
	if (locale === "zh") return zh_nav_language_fr(inputs)
	if (locale === "ar") return ar_nav_language_fr(inputs)
	if (locale === "fr") return fr_nav_language_fr(inputs)
	if (locale === "vi") return vi_nav_language_fr(inputs)
	if (locale === "sw") return sw_nav_language_fr(inputs)
	if (locale === "th") return th_nav_language_fr(inputs)
	if (locale === "bs") return bs_nav_language_fr(inputs)
	if (locale === "ja") return ja_nav_language_fr(inputs)
	if (locale === "ko") return ko_nav_language_fr(inputs)
	if (locale === "pt") return pt_nav_language_fr(inputs)
	if (locale === "it") return it_nav_language_fr(inputs)
	if (locale === "sv") return sv_nav_language_fr(inputs)
	if (locale === "nl") return nl_nav_language_fr(inputs)
	if (locale === "da") return da_nav_language_fr(inputs)
	if (locale === "nb") return nb_nav_language_fr(inputs)
	if (locale === "fi") return fi_nav_language_fr(inputs)
	if (locale === "pl") return pl_nav_language_fr(inputs)
	if (locale === "ru") return ru_nav_language_fr(inputs)
	if (locale === "tr") return tr_nav_language_fr(inputs)
	if (locale === "hi") return hi_nav_language_fr(inputs)
	if (locale === "id") return id_nav_language_fr(inputs)
	if (locale === "ms") return ms_nav_language_fr(inputs)
	if (locale === "cs") return cs_nav_language_fr(inputs)
	if (locale === "el") return el_nav_language_fr(inputs)
	if (locale === "he") return he_nav_language_fr(inputs)
	if (locale === "af") return af_nav_language_fr(inputs)
	if (locale === "hu") return hu_nav_language_fr(inputs)
	return en_nav_language_fr(inputs)
});